import * as Sentry from '@sentry/react';
import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class RawErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="h-screen flex flex-col items-center justify-center bg-abyss-950 text-foam-100 gap-4">
          <p className="text-lg font-semibold">오류가 발생했습니다.</p>
          <p className="text-foam-500 text-sm">새로고침 후 다시 시도해 주세요.</p>
          <button
            onClick={() => window.location.reload()}
            className="mt-2 px-5 py-2 rounded-lg bg-tide-500 hover:bg-tide-600 text-abyss-950 font-medium transition-colors text-sm"
          >
            새로고침
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

// Wrap with Sentry so uncaught render errors are automatically reported
export const ErrorBoundary = Sentry.withErrorBoundary(RawErrorBoundary, {
  fallback: (
    <div className="h-screen flex flex-col items-center justify-center bg-abyss-950 text-foam-100 gap-4">
      <p className="text-lg font-semibold">오류가 발생했습니다.</p>
      <p className="text-foam-500 text-sm">새로고침 후 다시 시도해 주세요.</p>
      <button
        onClick={() => window.location.reload()}
        className="mt-2 px-5 py-2 rounded-lg bg-tide-500 hover:bg-tide-600 text-abyss-950 font-medium transition-colors text-sm"
      >
        새로고침
      </button>
    </div>
  ),
});
